module.exports = __webpack_public_path__ + "static/media/29BDOS6.ea26905a.jpg";